// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "Pages_games_web_bacanagol_components_DynamicPhaseRenderer_index_js") return "63a58984a03b2be22760.css";
	// return url for filenames based on template
	return undefined;
};